<script>
	import CreateForm from "./CreateForm.svelte";
	export let userId;
</script>

<CreateForm isEdit={userId} />
